var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 27.04,
    viewBox: "0 0 24 27.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_639",
    "data-name": "Group 639",
    transform: "translate(-796 -1430.96)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calendar",
    transform: "translate(796.004 1430.502)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_638",
    "data-name": "Group 638"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_13",
    "data-name": "Line 13",
    x2: 16,
    transform: "translate(3.996 9.498)",
    fill: "none",
    stroke: "#00105c",
    strokeWidth: 2,
    strokeDasharray: "2 2.5"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_14",
    "data-name": "Line 14",
    x2: 16,
    transform: "translate(3.996 13.498)",
    fill: "none",
    stroke: "#00105c",
    strokeWidth: 2,
    strokeDasharray: "2 2.5"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_15",
    "data-name": "Line 15",
    x2: 16,
    transform: "translate(3.996 17.498)",
    fill: "none",
    stroke: "#00105c",
    strokeWidth: 2,
    strokeDasharray: "2 2.5"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_16",
    "data-name": "Line 16",
    x2: 8,
    transform: "translate(3.996 21.498)",
    fill: "none",
    stroke: "#00105c",
    strokeWidth: 2,
    strokeDasharray: "2 2.5"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_176",
    "data-name": "Rectangle 176",
    width: 22,
    height: 22,
    rx: 3,
    transform: "translate(797 1435)",
    fill: "none",
    stroke: "#00105c",
    strokeWidth: 2,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_733",
    "data-name": "Path 733",
    d: "M7588.6,1647v-3.04",
    transform: "translate(-6786 -213)",
    fill: "none",
    stroke: "#00105c",
    strokeWidth: 2,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_734",
    "data-name": "Path 734",
    d: "M7588.6,1647v-3.04",
    transform: "translate(-6775 -213)",
    fill: "none",
    stroke: "#00105c",
    strokeWidth: 2,
    opacity: 0.3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.54a60e31134ab1adc2a726e765a5b140.svg";
export { ForwardRef as ReactComponent };